import React, { PropTypes } from 'react';
import _ from 'lodash';
import cx from 'classnames';

import Input from 'components/forms/Input';




// ====================
// SWITCH INPUT
// ====================
export const SwitchInput = React.forwardRef(({ label, className, ...props }, ref) => (
  <Input
    {...props}
    ref={ref}
    className={cx("switch", className)}
    valueKey="checked"
    renderInput={inputProps => (
      <label>
        <span>{ label }</span>
        <div className={cx("switch-wrap", { on: inputProps.value })}>
          <input type="checkbox" {...inputProps} checked={inputProps.value} />
          <div className="switch-slider" />
          <div className="switch-label">{ inputProps.value ? "on" : "off" }</div>
        </div>
      </label>
    )} />
))
export default SwitchInput;

